import type { PlatformService } from '../application/platform/PlatformService';

export class WebBrowserPlatformService implements PlatformService {
  openInNewTab = (url: string) => {
    window.open(url, '_blank');
  };

  reload = () => {
    window.location.reload();
  };

  areCookiesEnabled = () => {
    try {
      const testCookieName = 'notSessionCookieTest';
      const in1minuteDate = new Date(Date.now() + 60000);
      document.cookie = `${testCookieName}=1; expires=${in1minuteDate.toUTCString()}; SameSite=Strict`;
      const cookiesEnabled = document.cookie.includes(`${testCookieName}=`);
      document.cookie = `${testCookieName}=1; expires=Thu, 01-Jan-1970 00:00:01 GMT; SameSite=Strict`;
      return cookiesEnabled;
    } catch (e) {
      return false;
    }
  };
}
